<template>
  <div style="display: flex;flex-direction: column;">
    <div>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="物料编码">
            <Input v-model="formItem.ProductID" placeholder="请输入物料编码"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="物料名称">
            <Input v-model="formItem.Product_Name" placeholder="请输入物料名称"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="大类名称">
            <Input v-model="formItem.Classification" placeholder="请输入大类名称"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem>
        <div style="float:right">
          <Button type="primary" style="margin-right:1rem" @click="QueryHandleClick">查询</Button>
        </div>
      </FormItem>
    </Form>
    </div>

     <Table  ref="selection" :columns="columns12" :data="Productinformlist" max-height="600" @on-select="SelecttionHandleClick">
    </Table>
    <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
    <Spin size="large" fix v-if="SpinShow"></Spin>
  </div>
</template>

<script>
import { NonStandardProductinformlistApi } from '../../../../api/Miscellaneous.js'
export default {
  name: 'NonStandardProduct',
  data () {
    return {
      formItem: {
        ProductID: '',
        Product_Name: '',
        Classification: ''
      },
      columns12: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '物料编码',
          key: 'ProductID'
        },
        {
          title: '物料名称',
          key: 'Product_Name'
        },
        {
          title: '属性汇总',
          key: 'Attribute_Summary'
        },
        {
          title: '物料大类',
          key: 'Classification'
        }
      ],
      Productinformlist: [],
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      SpinShow: false
    }
  },
  mounted: function () {
    this.GetProductinformlist()
  },
  methods: {
    GetProductinformlist () {
      NonStandardProductinformlistApi(this.formItem.ProductID, this.formItem.Product_Name, this.formItem.Classification, this.CurrentPage, this.pageSize).then(res => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.Productinformlist = res.Data.Table1
          this.SpinShow = false
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    SelecttionHandleClick (selection, row) {
      this.$emit('SelectionPHandleClick', row)
      this.GetProductinformlist()
    },
    QueryHandleClick () {
      this.GetProductinformlist()
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetProductinformlist()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetProductinformlist()
      }
    }
  }
}
</script>
